module.exports = __webpack_public_path__ + "img/four.c59d322e.jpg";